import { createAuth0 } from '@auth0/auth0-vue'

import { env } from '#app/services/env'

export const ALLOWED_ORG_ID = 'org_FO4OCk9qjqdjNkwc'

export default createAuth0({
  domain: env.VITE_AUTH0_DOMAIN,
  clientId: env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: env.VITE_AUTH0_AUDIENCE,
    organization: ALLOWED_ORG_ID,
  },
  useRefreshTokens: true,
  cacheLocation: 'localstorage',
})
